// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"bb702ddf","379":"a78b4de6","880":"2a394d5a"}[chunkId] + ".chunk.css";
};